module.exports = __webpack_public_path__ + "img/1349.ebdad429.gif";